<template>
  <v-container >
    <v-card class="elevation-0 ">
      <v-card-text>
        <v-row>
          <v-col cols="12" xl="3" lg="3" md="3" sm="6" v-for="(articulo, i) in filterArticulos" :key="i" v-if="i >= countMin && i <= countMax ">
            <v-card height="100%" class="elevation-5" v-on:dblclick="verDetalle(articulo)">
              <v-img 
                v-if="articulo.fotos.length > 0"
                class="mb-4"
                :src="url + articulo.fotos[0].image_name" 
                height="180"
                contain>
              </v-img> 

              <v-img 
                v-else
                class="mb-4"
                src="@/assets/blanco.jpg" 
                height="180"
                contain>
              </v-img> 
              <v-card-text class="py-0" >
                <h2>{{articulo.nomart}}</h2>
              </v-card-text>

              <v-card class="py-0 elevation-0 transparetion" height="70">
                <v-card-subtitle >
                  {{articulo.descrip}}
                </v-card-subtitle>
              </v-card>

              <v-card-actions >
                <strike v-if="articulo.pjedesc > 0"><h3 class="primary--text mr-2" >${{articulo.precio1}} MXN</h3></strike>
                <h2 class="primary--text mr-2" v-else>${{articulo.precio1}} MXN</h2>
              </v-card-actions>

              <v-card-actions >
                <h2 class="secondary--text" v-if="articulo.pjedesc > 0"><b>Oferta</b> ${{ articulo.prediocesc }} MXN</h2>
                <h2 class="white--text" v-else>a</h2>
              </v-card-actions>

              <v-card-actions >
                <v-spacer></v-spacer>
                <v-btn
                  block
                  color="primary"
                  class="buton_cart"
                  @click="addCarrito(articulo)"
                >
                  Agregar a carrito
                  <v-icon right>mdi-cart</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
          <v-col cols="12" align="center">
            <v-pagination
              v-model="page"
              :length="paginas"
              :total-visible="7"
            ></v-pagination>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex'
  var numeral = require('numeral');

  export default {
    data () {
      return {
        search:'',
        page: 1,
        paginas:0,

        url: '',
        sinImagen:'@/assets/blanco.jpg',

        countMax: 7,
        countMin: 0,

        img: 'https://teva.niceapp.cl/wp-content//uploads/2019/03/Paracetamol_Infantil_125MG_6S_HD.jpg',

        articulos:[],

      }
    },

    watch:{
      page(){
        var itemPerPage = this.page * 8
        this.countMax = itemPerPage - 1
        this.countMin = (this.countMax + 1) - 8
        console.log('cambie de pagina', this.page)
      }
    },

    created(){
      this.init()
      this.url = this.$http.options.root + 'fotos/'
    },

    methods:{
      ...mapActions('articulos',['traerArticulos']),
      ...mapActions('carrito',['carritoadd']),

      verDetalle(art){
        this.$router.push({ name: 'detart' , params:{ codigo:art.codigo} })
      },

      init(){
        this.traerArticulos().then(response=>{
          console.log(this.getArticulos)
          this.articulos = this.getArticulos
          this.articulos.forEach((element, index)=>{
            element.prediocesc = element.precio1 * (  (100 - element.pjedesc) * 0.01 ) 
            element.precio1 = numeral(element.precio1).format('0,0.00')
            element.prediocesc = numeral(element.prediocesc).format('0,0.00')
            if(index == (this.articulos.length-1)){
              this.paginacion()
            }
          })
          // calular la cantidad de páginas
        }).catch(error=>{console.log(error)})
      },


      addCarrito(art){
        // art.precio1 = this.unformat(art.precio1)
        this.carritoadd(art)
        this.$store.state.carrito.carritovisible = true
        art.precio1 = numeral(art.precio1).format('0,0.00')
      },

      unformat(string) {
        return numeral._.stringToNumber(string);
      },

      paginacion(){

        if((this.articulos.length /8)%2==0){
          this.paginas = this.articulos.length /8
        }else{
          this.paginas = parseInt((this.articulos.length /8) + 1)
          console.log(this.paginas)
        }
      },
    },

    computed:{
      ...mapGetters('articulos', ['getArticulos','getSearch']),
      

      filterArticulos: function(){
        var me = this
        if(this.articulos){
          return this.articulos.filter((art)=>{
            var nom = art.nomart.toLowerCase();
            return nom.match(this.getSearch.toLowerCase());
          })
        }
      },
    }
  }
</script>
<style scoped>
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: .5;
  position: absolute;
  width: 100%;
}


</style>